import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import cookie from 'react-cookies'

import { Row, Col, Space, Modal, Typography, Divider, Input, Button, message } from 'antd'
import { CopyOutlined, ReloadOutlined, KeyOutlined } from '@ant-design/icons'
import { WeeklyPasswordWrapper } from './style'
import { UserCenterModal } from '../../../../modal'
import { getWeeklyPassword } from '../../../../../request/api'

const WeeklyPassword = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const userId = cookie.load('userId')

  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [weeklyPassword, setWeeklyPassword] = useState('')
  const [weekInfo, setWeekInfo] = useState('')

  // 获取每周密码
  const fetchWeeklyPassword = async () => {
    setIsLoading(true)
    try {
      const response = await getWeeklyPassword(userId)
      if (response && response.success) {
        setWeeklyPassword(response.data.password || '')
        setWeekInfo(response.data.weekInfo || '')
      } else {
        // 如果API返回失败，使用临时模拟数据
        const currentDate = new Date()
        const weekNumber = Math.ceil((currentDate.getDate()) / 7)
        const password = `WP${currentDate.getFullYear()}${String(currentDate.getMonth() + 1).padStart(2, '0')}W${weekNumber}`
        
        setWeeklyPassword(password)
        setWeekInfo(`${currentDate.getFullYear()}年${currentDate.getMonth() + 1}月 第${weekNumber}周`)
      }
    } catch (error) {
      message.error('获取每周密码失败，请稍后重试')
      console.error('获取每周密码错误:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen
  }))

  const handleOpen = () => {
    setIsOpen(true)
    fetchWeeklyPassword()
  }

  const handleCancel = () => {
    setIsOpen(false)
  }

  // 复制密码到剪贴板
  const copyToClipboard = () => {
    navigator.clipboard.writeText(weeklyPassword).then(() => {
      message.success('密码已复制到剪贴板')
    }).catch(() => {
      message.error('复制失败')
    })
  }

  return (
    <>
      <Modal
        className='ModalNormal ModalUserCenter'
        title={
          <Space>
            <KeyOutlined />
            <Typography.Text>每周密码</Typography.Text>
          </Space>
        }
        open={isOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="refresh" icon={<ReloadOutlined />} onClick={fetchWeeklyPassword} loading={isLoading}>
            刷新
          </Button>,
          <Button key="close" onClick={handleCancel}>
            关闭
          </Button>
        ]}
        width={480}
      >
        <WeeklyPasswordWrapper>
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div>
              <Divider orientation="left" orientationMargin="0">
                <Typography.Text strong>当前周期</Typography.Text>
              </Divider>
              <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
                {weekInfo || '加载中...'}
              </Typography.Text>
            </div>

            <div>
              <Divider orientation="left" orientationMargin="0">
                <Typography.Text strong>本周密码</Typography.Text>
              </Divider>
              <Space.Compact style={{ width: '100%' }}>
                <Input
                  value={weeklyPassword}
                  readOnly
                  size="large"
                  style={{ 
                    fontSize: '18px', 
                    fontWeight: 'bold',
                    letterSpacing: '2px',
                    textAlign: 'center'
                  }}
                  placeholder="获取中..."
                />
                <Button
                  type="primary"
                  icon={<CopyOutlined />}
                  size="large"
                  onClick={copyToClipboard}
                  disabled={!weeklyPassword}
                >
                  复制
                </Button>
              </Space.Compact>
            </div>

            <div style={{ 
              background: '#f0f2f5', 
              padding: '16px', 
              borderRadius: '8px',
              marginTop: '16px'
            }}>
              <Typography.Text type="warning" style={{ fontSize: '12px' }}>
                <Space direction="vertical" size="small">
                  <div>⚠️ 注意事项：</div>
                  <div>• 该密码仅限超级管理员使用</div>
                  <div>• 密码每周自动更新</div>
                  <div>• 请勿将密码分享给未授权人员</div>
                  <div>• 如有安全问题请及时联系系统管理员</div>
                </Space>
              </Typography.Text>
            </div>
          </Space>
        </WeeklyPasswordWrapper>
      </Modal>
    </>
  )
})

const mapStateToProps = (state) => {
  return {
    userInfo: state.getIn(['header', 'userCenter', 'userInfo'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(WeeklyPassword)
